import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'


export const contactApi = createApi({
  reducerPath: 'contactApi',
  baseQuery: fetchBaseQuery({ baseUrl: 'https://panel.linket.me/api/contact' }),
  tagTypes: ['contact'],

  endpoints: (builder) => ({
    createContact: builder.mutation({
      query: (data) => ({
        url: 'create',
        method: 'POST',
        body: data,
      }),
      invalidatesTags: ['contact']
    }),
  }),
})

export const { useCreateContactMutation } = contactApi